<template>
    <div>
        <div @click="selctCurProd(prod)" class="prod_item" :class="{ 'slimMode': isSlimMode() }">
            <div class="img_container">
                <img v-if="image != null && hasImage" :src="image" @error="() => this.hasImage = false">
                <img v-else :src="noImageSrc">
            </div>
            <div class="name_container">
                <div class="container">
                    <span class="name" v-text="name"></span>
                </div>
            </div>
            <div class="price_container">
                <div class="container">
                    <template v-if="checkSignalsDiscount()">
                        <span class="from" v-if="exibApartir()">{{ getString('a_partir_de') }}</span>
                        <span class="price diff_price">{{ formatMoney(fullMinPrice) }}</span>
                        <span class="price" :class="{ 'bold': useBoldPrice() }">{{ formatMoney(minPrice) }}</span>
                    </template>
                    <template v-else>
                        <span class="from" v-if="exibApartir()">{{ getString('a_partir_de') }}</span>
                        <span class="price" :class="{ 'bold': useBoldPrice() }">{{ getMinPrice(prod) }}</span>
                    </template>
                </div>
            </div>
        </div>

        <div class="overlay" v-if="showOverlay" @click="cancelSuggestModal()"></div>
        <SuggestionsModal v-if="showSuggestionsModal" :suggestData="suggestData" :suggestModalDepth="suggestModalDepth"
            @suggestChoose="suggestChoose">
        </SuggestionsModal>
    </div>
</template>

<script>
import LocaleController from '@/assets/controllers/LocaleController'
import Util from '@/assets/libs/util'
import ProductController from '@/assets/controllers/ProductController'
import MinPriceController from '@/assets/controllers/MinPriceController'
import SuggestionsModal from '@/components/SuggestionsModal'

export default {
    name: 'ProductCard',
    props: [
        'name',
        'image',
        'price',
        'prod',
        'blockProds'
    ],
    components: {
        SuggestionsModal
    },
    data () {
        return {
            suggestData: {},
            suggestModalDepth: null,
            showSuggestionsModal: false,
            showOverlay: false,
            hasImage: true,
            noImageSrc: null,
            signalsDiscount: Util.getLocalConfigs('signalsDiscount'),
            junk: require('../../static/icons/junk-icon.png'),
            minPrice: 0,
            fullMinPrice: 0,
            removeProdutoSugestaoAutomatico: Util.getLocalConfigs('removeProdutoSugestaoAutomatico')
        }
    },
    created () {
        this.calculateMinPrice(this.prod)
    },
    mounted () {
        this.getImage()
        // this.noImageSrc = Util.getConfigImage('noImage') || this.junk
    },
    methods: {
        getString: function (key) {
            return LocaleController.getString(key)
        },
        getImage: async function () {
            this.noImageSrc = await Util.getConfigImage('noImage') || this.junk
            this.$forceUpdate()
        },
        isSlimMode: function () {
            return Util.isSlimMode()
        },
        useBoldPrice: function () {
            return Util.useBoldPrice()
        },
        suggestChoose: async function (prod) {
            this.suggestModalDepth++
            await this.closeSuggestModal()
            this.selctCurProd(prod)
        },
        openSuggestModal: function () {
            this.showSuggestionsModal = true
            this.showOverlay = true
        },
        closeSuggestModal: function () {
            let self = this
            return new Promise(function (resolve, reject) {
                try {
                    self.showSuggestionsModal = false
                    resolve(true)
                } catch (e) {
                    reject(e)
                }
            })
        },
        cancelSuggestModal: function () {
            this.suggestModalDepth = null
            this.showOverlay = false
            this.closeSuggestModal()
        },
        exibApartir: function () {
            return (Util.exibApartir() && Util.variablePrice(this.prod))
        },
        formatMoney: function (price) {
            return Util.formatMoney(price)
        },
        selctCurProd: async function (prod) {
            let productSuggestion = prod.productSuggestion || []
            let requestSuccess = productSuggestion != null && productSuggestion !== []
            let productHasSuggestions = (productSuggestion.suggestions && productSuggestion.suggestions[prod.productCode] && productSuggestion.suggestions[prod.productCode].length > 0)
            let hasSuggestionsForCurrentDepth = false
            let suggestedRaw = []

            if (requestSuccess && productHasSuggestions) {
                suggestedRaw = productSuggestion.suggestions[prod.productCode]
                hasSuggestionsForCurrentDepth = this.checkSuggestionsForDepth(suggestedRaw)
            }

            if (hasSuggestionsForCurrentDepth) {
                this.handleProductSuggestion(prod, suggestedRaw)
            } else {
                this.selectCurProd(prod)
            }
        },
        checkSuggestionsForDepth: function (suggestedRaw) {
            let currentDepth = this.suggestModalDepth
            let blockProds = this.blockProds || []
            let hourlyUnavailableProds = Util.getLocalVar('hourlyUnavailableProds') || []

            let suggestedFlavours = []
            let suggestedSizes = []
            let suggestedCombos = []

            suggestedRaw.forEach(element => {
                let prodIsNotBlocked = blockProds.find(blockProd => blockProd === element.productSuggestion) === undefined &&
                    hourlyUnavailableProds.find(prod => prod === element.productSuggestion) === undefined

                if (element.suggestionType === 4 && prodIsNotBlocked) {
                    suggestedFlavours.push(element)
                } else if (element.suggestionType === 3 && prodIsNotBlocked) {
                    suggestedSizes.push(element)
                } else if (element.suggestionType === 5 && prodIsNotBlocked) {
                    suggestedCombos.push(element)
                }
            })

            let anySuggestedFlavour = suggestedFlavours.length > 0 &&
                !(suggestedFlavours.length === 1 && suggestedFlavours[0].productSuggestion === suggestedFlavours[0].productCode)
            let anySuggestedSize = suggestedSizes.length > 0 &&
                !(suggestedSizes.length === 1 && suggestedSizes[0].productSuggestion === suggestedSizes[0].productCode)
            let anysuggestedCombo = suggestedCombos.length > 0 &&
                !(suggestedCombos.length === 1 && suggestedCombos[0].productSuggestion === suggestedCombos[0].productCode)

            let depthZeroConditions = (currentDepth === null || currentDepth === 0) && (anySuggestedFlavour || anySuggestedSize || anysuggestedCombo)
            let depthOneConditions = currentDepth === 1 && (anySuggestedSize || anysuggestedCombo)
            let depthTwoConditions = currentDepth === 2 && anysuggestedCombo

            return depthZeroConditions || depthOneConditions || depthTwoConditions
        },
        handleProductSuggestion: function (clickedProduct, suggestedRaw) {
            let suggestedFlavours = []
            let suggestedSizes = []
            let suggestedCombos = []

            // Separa as sugestões de acordo com o tipo
            suggestedRaw.forEach(element => {
                let prod = ProductController.getProdItem(element.productSuggestion)

                if (prod) {
                    let hourlyUnavailableProds = Util.getLocalVar('hourlyUnavailableProds') || []
                    let prodIsNotBlocked = hourlyUnavailableProds.find(element => element === prod.productCode) === undefined

                    if (element.suggestionType === 4 && prodIsNotBlocked) {
                        suggestedFlavours.push(prod)
                    } else if (element.suggestionType === 3 && prodIsNotBlocked) {
                        suggestedSizes.push(prod)
                    } else if (element.suggestionType === 5 && prodIsNotBlocked) {
                        suggestedCombos.push(prod)
                    }
                }
            })

            // Caso o produto já clicado seja o único de algum array de sugestões, limpa aquele array
            if (suggestedFlavours.length === 1 && suggestedFlavours[0].productCode === clickedProduct.productCode) {
                suggestedFlavours = []
            }

            if (suggestedSizes.length === 1 && suggestedSizes[0].productCode === clickedProduct.productCode) {
                suggestedSizes = []
            }

            if (suggestedCombos.length === 1 && suggestedCombos[0].productCode === clickedProduct.productCode) {
                suggestedCombos = []
            }

            // Verifica se o produto originalmente clicado precisa ser inserido em algum grupo de sugestões
            if (!this.removeProdutoSugestaoAutomatico) {
                if (suggestedFlavours.length > 0) {
                    let hasClickedProduct = suggestedFlavours.find((element) => element.productCode === clickedProduct.productCode)
                    if (!hasClickedProduct) suggestedFlavours.unshift(clickedProduct)
                }

                if (suggestedSizes.length > 0) {
                    let hasClickedProduct = suggestedSizes.find((element) => element.productCode === clickedProduct.productCode)
                    if (!hasClickedProduct) suggestedSizes.unshift(clickedProduct)
                }

                if (suggestedCombos.length > 0) {
                    let hasClickedProduct = suggestedCombos.find((element) => element.productCode === clickedProduct.productCode)
                    if (!hasClickedProduct) suggestedCombos.unshift(clickedProduct)
                }
            }

            // Se for o primeiro modal de sugestão a ser aberto para esse produto, inicializa o contador suggestModalDepth
            // de acordo com o nível da primeira sugestão a ser exibida
            if (this.suggestModalDepth === null) {
                if (suggestedFlavours.length === 0 && suggestedSizes.length === 0) {
                    this.suggestModalDepth = 2
                } else if (suggestedFlavours.length === 0) {
                    this.suggestModalDepth = 1
                } else {
                    this.suggestModalDepth = 0
                }
            }

            this.suggestData = {
                flavours: this.suggestModalDepth === 0 ? suggestedFlavours : [],
                sizes: this.suggestModalDepth <= 1 ? suggestedSizes : [],
                combos: suggestedCombos
            }

            let hasAnyAvailableSuggestion = this.suggestData.flavours.length > 0 || this.suggestData.sizes.length > 0 ||
                this.suggestData.combos.length > 0

            if (hasAnyAvailableSuggestion) {
                this.openSuggestModal()
            } else {
                this.selectCurProd(clickedProduct)
            }
        },
        selectCurProd: function (prod) {
            this.suggestModalDepth = null
            this.showOverlay = false
            this.$emit('selectCurprod', prod)
        },
        calculateMinPrice: function (prod) {
            this.minPrice = MinPriceController.getMinPrice(prod)
            this.minPrice = parseFloat(this.minPrice.replace('R$', '').replace(',', '.'))
            this.fullMinPrice = parseFloat(prod.calculatedFullMinPrice)
        },
        checkSignalsDiscount: function () {
            return this.signalsDiscount && (((this.minPrice + 1) < this.fullMinPrice))
        },
        getMinPrice: function (prod) {
            return MinPriceController.getMinPrice(prod)
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='less'>
@import (reference) url("../assets/common.less");

.prod_item {
    position: relative;
    background-color: @white;
    padding: 0;
    text-align: center;
    margin: 20px;
    box-shadow: 5px 0px 5px rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    display: grid;
    grid-template-rows: 150px 100px 60px;

    // height: 300px;
    .container {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: calc(100% - 30px);
        padding: 0 15px;
    }

    &.slimMode {
        box-shadow: unset;
        grid-template-rows: 150px auto 40px;
    }
}

.img_container {
    img {
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
        object-fit: contain;
        width: 100%;
        max-height: 130px;
        height: auto;
        margin: auto;
        // margin-top: 20px;
        display: block;
    }
}

.name_container {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 90px;
    max-height: 150px;
    padding: 0 10px;

    .container {
        position: static;
        transform: none;
        width: 100%;
        padding: 0;
    }

    .name {
        font-family: @default-font;
        font-size: 1.3rem;
        display: block;
        max-width: 100%;
        // text-transform: uppercase;
        text-align: center;
        margin: 0;
        padding: 0;
        line-height: 1.4;
    }
}

.price_container {
    position: relative;

    .from {
        text-transform: uppercase;
        font-size: 1rem;
        color: @primary-dark;
        padding-top: 15px;
    }

    .price {
        font-family: @default-font;
        font-size: 1.2rem;
        color: var(--price-font-color);
        margin: 0;
    }

    .price.diff_price {
        text-decoration: line-through;
        color: @disabled-color;
        font-size: 1rem;
    }

    .bold {
        font-weight: bold;
    }
}

.overlay {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    background: rgba(0, 0, 0, 0.8);
    z-index: 2;
}

@media (max-width: 698px) {

    // Gertec SK210
    .prod_item {
        box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.1);
        margin: 5px;
        grid-template-rows: 2fr 1fr 1fr;
        height: 95%;

        &.slimMode {
            box-shadow: unset;
            grid-template-rows: 2fr 1fr 1fr;
        }
    }

    .img_container {
        img {
            max-height: 100px;
            margin-top: 0;
        }
    }

    .name_container {
        min-height: 40px;
        max-height: 70px;

        .name {
            font-size: 13px;
        }
    }

    .price_container {
        margin-bottom: 5px;

        .container {
            .price.diff_price {
                font-size: 12px;
            }

            .price {
                font-size: 14px;
            }

            .price.full-min-price {
                font-size: 12px;
            }
        }

        .from {
            font-size: 12px;
            padding-top: 0;
        }

        .price {
            font-size: 14px;
        }

        .price.full-min-price {
            font-size: 12px;
        }
    }
}

@media (min-width: 901px) and (max-width: 1025px) {

    //@tablet
    .prod_item {
        margin: 10px;
        grid-template-rows: 130px 80px 60px;

        .container {
            width: calc(100% - 30px);
            padding: 0 15px;
        }

        &.slimMode {
            box-shadow: unset;
            grid-template-rows: 130px auto 50px;
        }
    }

    .img_container {
        img {
            max-height: 140px;
            height: auto;
            margin: auto;
            margin-top: 0;
            object-fit: contain;
            display: block;
        }
    }

    .name_container {
        min-height: 70px;
        max-height: 100px;

        .name {
            font-size: 0.9rem;
        }
    }
}

@media (min-width: 699px) and (max-width: 900px) {
    .prod_item {
        grid-template-rows: 140px auto 60px;
        // width: fit-content;
        width: calc(100% - 10px);
        margin: 10px;
    }

    .img_container {
        img {
            max-height: 140px;
            height: auto;
            margin: auto;
            margin-top: 0;
            object-fit: contain;
            display: block;
        }
    }

    .name_container {
        min-height: 70px;
        max-height: 100px;

        .name {
            font-size: 1.1rem;
        }
    }

    .price_container {
        .from {
            text-transform: uppercase;
            font-size: 1rem;
            color: @primary-dark;
            padding-top: 10px;
        }

        .price {
            font-size: 1.2rem;
        }

        .price.full-min-price {
            font-size: 1rem;
        }
    }
}

@media (orientation: landscape) {
    .prod_item {
        margin: 10px;
        grid-template-rows: 150px 60px 40px;

        .container {
            width: calc(100% - 30px);
            padding: 0 15px;
        }

        &.slimMode {
            box-shadow: unset;
            grid-template-rows: 130px 70px 50px;
        }
    }

    .img_container {
        img {
            max-height: 150px;
            height: auto;
            min-height: 130px;
            max-height: 160px;
            margin-top: 0;
        }
    }

    .name_container {
        .name {
            font-size: 1rem;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/ProductCard.vue